/**
 * Axiom Labs welcome popup: wipe-the-haze scratch-off.
 * Runs on the tingle modal clone (innerHTML copy of newsletter-popup).
 */
(function () {
  'use strict';

  function isHomepage() {
    return !!(document.body && document.body.classList.contains('index'));
  }

  function popupSeen() {
    return typeof getCookie === 'function' && getCookie('newsletter_popup');
  }

  function markPopupSeen() {
    if (typeof setCookie === 'function') setCookie('newsletter_popup', '1', 30);
  }

  function lockWelcomePopup() {
    var el = document.querySelector('newsletter-popup');
    if (!el) return;
    if (!isHomepage() || popupSeen()) {
      el.setAttribute('data-show', '');
    }
  }

  function closeOffHomePopup() {
    if (isHomepage()) return;
    document.querySelectorAll('.newsletter-popup-modal').forEach(function (modal) {
      modal.remove();
    });
    if (document.body) document.body.classList.remove('tingle-enabled');
  }

  lockWelcomePopup();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockWelcomePopup);
  }

  var popupObserver = new MutationObserver(function () {
    closeOffHomePopup();
    if (isHomepage() && document.querySelector('.newsletter-popup-modal')) {
      markPopupSeen();
    }
  });
  function watchPopups() {
    if (!document.body) return;
    popupObserver.observe(document.body, { childList: true, subtree: true });
    lockWelcomePopup();
    closeOffHomePopup();
  }
  if (document.body) watchPopups();
  else document.addEventListener('DOMContentLoaded', watchPopups);

  class AxiomScratch extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      if (!this.closest('.tingle-modal')) return;
      this._booted = true;
      requestAnimationFrame(function () {
        this.setup();
      }.bind(this));
    }

    setup() {
      this.canvas = this.querySelector('.axiom-scratch__foil');
      this.stage = this.querySelector('.axiom-scratch__stage');
      this.prize = this.querySelector('.axiom-scratch__prize');
      this.skip = this.querySelector('[data-scratch-skip]');
      this.copyBtn = this.querySelector('[data-scratch-copy]');
      this.code = this.dataset.code || 'Welcome10';
      this.threshold = parseFloat(this.dataset.threshold || '0.48');
      this.drawing = false;
      this.revealed = false;
      this.lastCheck = 0;

      if (!this.canvas || !this.stage) return;

      this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
      this.resize();
      this.paintFoil();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.reveal();
        return;
      }

      this.onResize = this.resize.bind(this);
      window.addEventListener('resize', this.onResize);

      this.canvas.addEventListener('pointerdown', this.onDown.bind(this));
      this.canvas.addEventListener('pointermove', this.onMove.bind(this));
      this.canvas.addEventListener('pointerup', this.onUp.bind(this));
      this.canvas.addEventListener('pointerleave', this.onUp.bind(this));
      this.canvas.addEventListener('pointercancel', this.onUp.bind(this));

      if (this.skip) this.skip.addEventListener('click', this.reveal.bind(this));
      if (this.copyBtn) this.copyBtn.addEventListener('click', this.copyCode.bind(this));

      var claim = this.querySelector('.axiom-scratch__claim');
      if (claim) claim.setAttribute('inert', '');
    }

    resize() {
      if (this.revealed) return;
      var rect = this.stage.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.max(0, Math.round(rect.width));
      var h = Math.max(0, Math.round(rect.height));
      if (w < 8 || h < 8) {
        this._resizeTries = (this._resizeTries || 0) + 1;
        if (this._resizeTries < 40) requestAnimationFrame(this.resize.bind(this));
        return;
      }
      this._resizeTries = 0;
      this.cssW = w;
      this.cssH = h;
      this.canvas.width = Math.round(w * dpr);
      this.canvas.height = Math.round(h * dpr);
      this.canvas.style.width = w + 'px';
      this.canvas.style.height = h + 'px';
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      this.paintFoil();
    }

    paintFoil() {
      var ctx = this.ctx;
      var w = this.cssW;
      var h = this.cssH;
      if (!ctx || !w || !h) return;

      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#7d8793');
      g.addColorStop(0.45, '#c5ccd4');
      g.addColorStop(1, '#6e7884');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      var speckle = ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
      var data = speckle.data;
      for (var i = 0; i < data.length; i += 16) {
        var n = (Math.random() - 0.5) * 42;
        data[i] = Math.max(0, Math.min(255, data[i] + n));
        data[i + 1] = Math.max(0, Math.min(255, data[i + 1] + n));
        data[i + 2] = Math.max(0, Math.min(255, data[i + 2] + n));
      }
      ctx.putImageData(speckle, 0, 0);
      ctx.setTransform(Math.min(window.devicePixelRatio || 1, 2), 0, 0, Math.min(window.devicePixelRatio || 1, 2), 0, 0);

      ctx.strokeStyle = 'rgba(255,255,255,0.16)';
      ctx.lineWidth = 1;
      for (var x = -h; x < w + h; x += 14) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x + h, h);
        ctx.stroke();
      }

      ctx.fillStyle = 'rgba(18, 22, 28, 0.78)';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '700 15px system-ui, -apple-system, sans-serif';
      ctx.fillText('SCRATCH TO REVEAL', w / 2, h / 2 - 10);
      ctx.font = '500 12px system-ui, -apple-system, sans-serif';
      ctx.fillStyle = 'rgba(18, 22, 28, 0.55)';
      ctx.fillText('Wipe like you’re detailing the paint', w / 2, h / 2 + 16);
    }

    point(e) {
      var rect = this.canvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    }

    onDown(e) {
      if (this.revealed) return;
      e.preventDefault();
      this.drawing = true;
      this.classList.add('is-scratching');
      try {
        this.canvas.setPointerCapture(e.pointerId);
      } catch (err) {}
      this.scratch(this.point(e));
    }

    onMove(e) {
      if (!this.drawing || this.revealed) return;
      e.preventDefault();
      this.scratch(this.point(e));
    }

    onUp() {
      this.drawing = false;
    }

    scratch(pt) {
      var ctx = this.ctx;
      var radius = Math.max(22, Math.min(this.cssW, this.cssH) * 0.09);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(pt.x, pt.y, radius, 0, Math.PI * 2);
      ctx.fill();

      var now = Date.now();
      if (now - this.lastCheck < 80) return;
      this.lastCheck = now;
      if (this.clearedRatio() >= this.threshold) this.reveal();
    }

    clearedRatio() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var pixels = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
      var cleared = 0;
      var total = 0;
      var step = 16;
      for (var i = 3; i < pixels.length; i += step) {
        total += 1;
        if (pixels[i] < 40) cleared += 1;
      }
      return total ? cleared / total : 0;
    }

    reveal() {
      if (this.revealed) return;
      this.revealed = true;
      this.drawing = false;
      this.classList.add('is-revealed');
      this.classList.remove('is-scratching');
      if (this.prize) this.prize.setAttribute('aria-hidden', 'false');
      if (this.canvas) {
        this.canvas.style.opacity = '0';
        this.canvas.style.pointerEvents = 'none';
      }
      var claim = this.querySelector('.axiom-scratch__claim');
      if (claim) claim.removeAttribute('inert');
      window.removeEventListener('resize', this.onResize);
      this.claimWelcomeCode();
      var email = this.querySelector('input[type="email"]');
      if (email) {
        setTimeout(function () {
          email.focus({ preventScroll: true });
        }, 420);
      }
    }

    claimWelcomeCode() {
      var code = this.code || 'Welcome10';
      try {
        localStorage.setItem('axiom_pending_discount', code);
      } catch (e) {}
      if (window.AxiomCart && typeof window.AxiomCart.setPendingDiscount === 'function') {
        window.AxiomCart.setPendingDiscount(code);
      }
      if (window.AxiomCart && typeof window.AxiomCart.applyDiscountCode === 'function') {
        window.AxiomCart.applyDiscountCode(code, { silent: true });
      } else {
        var root =
          (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        root = root.replace(/\/?$/, '/');
        fetch(root + 'discount/' + encodeURIComponent(code), {
          credentials: 'same-origin',
          redirect: 'follow',
        }).catch(function () {});
      }
    }

    copyCode() {
      var btn = this.copyBtn;
      this.claimWelcomeCode();
      var done = function () {
        if (!btn) return;
        btn.textContent = 'Copied · applied';
        btn.classList.add('is-copied');
        setTimeout(function () {
          btn.textContent = 'Copy';
          btn.classList.remove('is-copied');
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.code).then(done).catch(done);
      } else {
        done();
      }
    }
  }

  if (!customElements.get('axiom-scratch')) {
    customElements.define('axiom-scratch', AxiomScratch);
  }
})();
